<!--业主添加和修改弹窗-->
<template>
	<div class="addNewOwnerDialogBody">
		<!--新增业主-->
		<el-dialog :title="title" :visible.sync="addOwnerShow">
			<div style="display: flex;width: 100%;">
				<div class="dialog-from">
					<el-form :model="ownerForm" >
						<el-form-item label="业主编号" :label-width="formLabelWidth" :required="nonEmpty">
							<el-input v-model="ownerForm.rfid" autocomplete="off" placeholder="WD123456789"></el-input>
						</el-form-item>
						<el-form-item label="业主姓名" :label-width="formLabelWidth" :required="nonEmpty">
							<el-input v-model="ownerForm.username" autocomplete="off" placeholder="请输入业主姓名"></el-input>
						</el-form-item>
						<el-form-item label="性别" :label-width="formLabelWidth" :required="nonEmpty">
							<el-radio-group v-model="ownerForm.gender">
								<el-radio label="男"></el-radio>
								<el-radio label="女"></el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item label="联系方式" :label-width="formLabelWidth" :required="nonEmpty">
							<el-input v-model="ownerForm.mobile" autocomplete="off" placeholder="请输入联系方式"></el-input>
						</el-form-item>
						<el-form-item label="地址" :label-width="formLabelWidth">
							<el-input v-model="ownerForm.address" autocomplete="off" placeholder="请输入地址"></el-input>
						</el-form-item>
						<el-form-item label="余额告警值(元)" :label-width="formLabelWidth" :required="nonEmpty">
							<el-input v-model.number="ownerForm.balanceAlarm" autocomplete="off" placeholder="请输入余额告警值"></el-input>
						</el-form-item>
						<el-form-item label="欠费自动拉闸" :label-width="formLabelWidth">
							<el-radio-group v-model="ownerForm.isAutomaticBrake">
								<el-radio label="是"></el-radio>
								<el-radio label="否"></el-radio>
							</el-radio-group>
							<el-input style="width: 74%;margin-left: 10px;" v-show="ownerForm.isAutomaticBrake=='是'" v-model="ownerForm.amountOfArrears" autocomplete="off" placeholder="请输入欠费金额"></el-input>
						</el-form-item>
						<el-form-item label="使用银行代扣" :label-width="formLabelWidth">
							<el-radio-group v-model="ownerForm.cardState">
								<el-radio label="是"></el-radio>
								<el-radio label="否"></el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item label="工行卡号" :label-width="formLabelWidth" v-show="ownerForm.cardState=='是'">
							<el-input v-model="ownerForm.cardNumbers" autocomplete="off" placeholder="请输入工行卡号"></el-input>
						</el-form-item>
						<el-form-item label="登录名" :label-width="formLabelWidth" :required="nonEmpty">
							<el-input v-model="ownerForm.usercode" autocomplete="off" placeholder="请输入登录名"></el-input>
						</el-form-item>
						<el-form-item v-if="isEdit" label="登录密码" :label-width="formLabelWidth" :required="nonEmpty">
							<el-input v-model="ownerForm.password" type="password" auto-complete="off" placeholder="请输入密码"></el-input>
						</el-form-item>
						<el-form-item v-else label="新密码" :label-width="formLabelWidth" :required="nonEmpty">
							<el-input v-model="ownerForm.password" type="password" auto-complete="off" placeholder="请输入密码"></el-input>
						</el-form-item>
						<el-form-item v-if="isEdit" label="确认登录密码" :label-width="formLabelWidth" :required="nonEmpty">
							<el-input v-model="ownerForm.password2" type="password" auto-complete="off" placeholder="请输入密码"></el-input>
						</el-form-item>
						<el-form-item v-else label="确认新密码" :label-width="formLabelWidth" :required="nonEmpty">
							<el-input v-model="ownerForm.password2" type="password" auto-complete="off" placeholder="请输入密码"></el-input>
						</el-form-item>
						<el-form-item label="绑定的电表" :label-width="formLabelWidth" v-show='isEdit' :required="nonEmpty">
							<el-input v-model="deviceNameList" placeholder="请选择电表" :disabled="true" autocomplete="off"></el-input>
						</el-form-item>
						<el-form-item label="绑定的水表" :label-width="formLabelWidth" v-show='isEdit' :required="nonEmpty">
							<el-input v-model="deviceWaterNameList" placeholder="请选择水表" :disabled="true" autocomplete="off"></el-input>
						</el-form-item>
					</el-form>
				</div>
				<div class="dialog-device" v-show='isEdit'>
					<div style="height: 45%">
						<elCheckBoxTree :dataList="deviceListFilter" columns="选择电表" @checkItem="checkItemList"></elCheckBoxTree>
					</div>

					<div style="height: 45%;margin-top: 10px">

						<elCheckBoxTree :dataList="deviceWaterListFilter" columns="选择水表" @checkItem="checkWaterItemList"></elCheckBoxTree>
					</div>

				</div>

			</div>
			<div slot="footer" class="dialog-footer" style="width:90%;">
				<el-form>
					<el-form-item label="分摊电费" :label-width="formLabelWidth" :required="nonEmpty">
						<div v-for="item in divideList" style="display: flex; width:100%;">
							<divideItem :divideItemList="divideItemList" :divideItemACList="divideItemACList" :itemid="item.itemid" :item2id="item.item2id" :type="item.type" :area="item.area" :index="item.index" @delete="delDevideItem" @updateItem="updateItem"></divideItem>
						</div>
						<div style="width:100%;display:flex;">
							<el-select v-model="tempType" placeholder="类型" style="width:25%">
								<el-option v-for="item in divideItemTypeList" :key="item.value" :label="item.label" :value="item.value">
								</el-option>
							</el-select>
							<el-select v-model="tempItem" placeholder="项目" style="width:25%">
								<el-option v-for="item in divideItemList" v-show="checkType1(item)" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
							<el-select v-model="tempItem2" v-if="tempType == 1" placeholder="内机" style="width:25%">
								<el-option v-for="item in divideItemACList" v-show="checkType2(item)" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
							<el-input v-show="tempType != 1" v-model="tempArea" placeholder="面积" style="width:25%"></el-input>
							<el-button v-on:click="addDivideItem">增加</el-button>
						</div>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="cancelAdd">取 消</el-button>
				<el-button type="primary" @click="confirm">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import electricMeterTree from '@/components/module/meterReading/electricMeterTree.vue'
	import elCheckBoxTree from '@/components/module/tree/elCheckBoxTree.vue'
	import ownerManagerStore from '../ownerManagerStore.js'
	import divideItem from './divideItem.vue';
	export default {
		components: {
			elCheckBoxTree,
			divideItem,
		},
		props: {
		},
		data() {
			return {
				formLabelWidth: '130px',
				addOwnerShow: false,
				title: '',
				ownerForm: {
					id: '',
					rfid: '',
					username: '',
					userCode: '',
					gender: '男',
					mobile: '',
					address: '',
					password: '',
					password2: '',
					accountTime: new Date().getTime(),
					cardNumbers: '',
					cardTypes: 'ICBC',
					balanceAlarm: '',
					isAutomaticBrake: '否',
					amountOfArrears: '',
					cardState: '否',
					reportDir: '',
					tempType:'type',
					tempItem:'itemid',
					tempArea:0
				},
				divideList: [],
				tempType:'',
				tempItem:'',
				tempItem2:'',
				tempArea:'',
				ownerRoleId: '', //菜单权限
				deviceListName: '',
				deviceNameList: '', //绑定电表的设备（一对多）
				devNos: '',//电表设备号一对多
				deviceWaterNameList : '',//绑定水表的设备（一对多）
				devWaterNos : '',//水表设备号一对多
				boxVue:"",
				boxWaterVue:"绑定水表",
				selectDeviceList: {}, //选中的设备
				isEdit: true, //是否为编辑
				nonEmpty:true,//显示红星
				divideItemList:[],//分摊项目列表
				divideItemACList:[],//空调内机
				divideItemTypeList: [{label: '空调', value:'1'},{label: '公共(内部)', value:'2'},{label: '公共(外部)', value:'3'}],
			}
		},
		created() {

			this.defaultData()
		},
		mounted() {

			this.initDivideItemList();

		},
		destroyed() {

		},
		computed: {
			rules() {
				return ownerManagerStore.state.isNullList
			},
			// 当前unit下的所有抄表nos
			deviceNos() {
				return ownerManagerStore.state.deviceNos
			},
			deviceListFilter() {
				var tree = copy(this.$store.deviceStore.getters.getReadDeviceTree)
				var meterTree = filterTreeRecursive([copy(tree)], item => {
					return !(!item.entityName == "VirtualDevicePojo" && !this.deviceNos.includes(item.no))
				})
				let list = filterTreeRecursive(meterTree, item => {
					//临时注释
					//return true;
					if(item.type == "group") {
						return true
					} else {
						return !this.bindedDeviceNos.includes(item.no)
					}
				})
				//console.info("OLD:"+JSON.stringify(deviceList(list)));
				return deviceList(list)
				// this.$api.deviceApi.getReadDeviceTreeByAppType(null, null,1,respon=>{
				// 	debugger
				// 	var tree =copy(respon);
				//
				// 	var meterTree = filterTreeRecursive([copy(tree)], item => {
				// 		return !(!item.entityName == "VirtualDevicePojo" && !this.deviceNos.includes(item.no))
				// 	})
				// 	let list = filterTreeRecursive(meterTree, item => {
				//
				// 		//return true;
				// 		if(item.type == "group") {
				// 			return true
				// 		} else {
				// 			return !this.bindedDeviceNos.includes(item.no)
				// 		}
				// 	})
				// 	console.info("new:"+JSON.stringify(deviceList(list)));
				// 	let  a = deviceList(list);
				// 	return a;
				//
				// })

			},

			deviceWaterListFilter() {
				var tree = copy(this.$store.deviceStore.getters.getReadDeviceTree)
				var meterTree = filterTreeRecursive([copy(tree)], item => {
					return !(!item.entityName == "VirtualDevicePojo" && !this.deviceNos.includes(item.no))
				})
				let list = filterTreeRecursive(meterTree, item => {

					//return true;
					if(item.type == "group") {
						return true
					} else {
						return !this.bindedDeviceNos.includes(item.no)
					}
				})
				return deviceList(list)
			},

			bindedDeviceNos() {
				return ownerManagerStore.state.bindedDeviceNos
			},
			nowUnit() {
				return this.$store.unitStore.state.nowUnit
			}
		},
		watch: {
			tempType(nv, ov){
				this.tempItem = '';
				this.tempItem2 = '';
			},
			tempItem(nv, ov){
				this.tempItem2 = '';
			},
			tempItem2(nv, ov){

			}
		},
		methods: {
			//虚拟设备树数据转换
			 deviceList(list) {
				//debugger
				let elementList = JSON.parse(JSON.stringify(list).replace(/next/g, "children"))
				elementList = JSON.parse(JSON.stringify(elementList).replace(/name/g, "label"))
				return elementList
			},
			addDivideItem(){
			 	//debugger
				if(this.tempType == '' && this.tempItem == '' && this.tempArea == ''){
					this.$message("请先输入内容")
					return;
				}
				if(this.divideList == null || this.divideList == undefined){
					this.divideList = [];
				}
				this.divideList[this.divideList.length] = {
					index:this.divideList.length,
					id:-1,
					type: this.tempType,
					itemid: this.tempItem,
					item2id: this.tempItem2,
					area:this.tempArea
				}

				//console.info("addDivideItem:"+JSON.stringify(this.divideList));

				this.tempType = '';
				this.tempItem = '';
				this.tempItem2 = '';
				this.tempArea = '';
			},
			delDevideItem(index){
				var nl = [];
				for(var i=0; i<this.divideList.length; i++){
					if(i == index){
						continue;
					}
					nl[nl.length] = this.divideList[i];
				}
				for(var i=0; i<nl.length; i++){
					nl[i].index = i;
				}
				this.divideList = nl;
			},
			updateItem(index, item, value){
				//console.info("index:"+index)
				//console.info("item:"+item)
				//console.info("value:"+value)
				this.divideList[index][item] = value;
			},

			//2020-10-12 LXK 业主设备一对一
			// checkItemList(list) {
			// 	//选中的设备
			// 	this.deviceListName = list.label
			// 	this.selectDeviceList = list
			// },

			//2020-10-12 LXK 业主电表设备一对多
			checkItemList(list) {
				//debugger
				this.deviceNameList = ''
				this.devNos=''
				list.forEach((item, i) => {
					if(item.type == 'virtualDevice') {
						if(i + 1 < list.length) {
							this.deviceNameList += item.label + ','
							this.devNos += item.no + ','
						} else {
							this.deviceNameList += item.label
							this.devNos += item.no
						}
					}
				})
			},


			//2020-10-12 LXK 业主水表设备一对多
			checkWaterItemList(list) {
				//debugger
				this.deviceWaterNameList = ''
				this.devWaterNos=''
				list.forEach((item, i) => {
					if(item.type == 'virtualDevice') {
						if(i + 1 < list.length) {
							this.deviceWaterNameList += item.label + ','
							this.devWaterNos += item.no + ','
						} else {
							this.deviceWaterNameList += item.label
							this.devWaterNos += item.no
						}
					}
				})
			},


			//2020-10-12 lxk取消
			cancelAdd(){
				this.addOwnerShow = false;
				this.deviceNameList = '';
				this.devNos='';
				//this.setcheckedKeyNull();
			},
			// 表单校验
			validForm(form) {
			 	//debugger
				var errorTips = "";
				var regular = [{
					filed: 'rfid',
					tips: '请填写业主编号！'
				},{
					filed: 'username',
					tips: '请填写业主姓名！'
				},{
					filed: 'mobile',
					tips: '请填写联系方式！'
				},{
					filed: 'balanceAlarm',
					tips: '请填写余额告警值！'
				},{
					filed: 'usercode',
					tips: '请填写登录名！'
				},{
					filed: 'password',
					tips: '请写登录密码！'
				},{
					filed: 'password2',
					tips: '请写确认登录密码！'
				}];
				regular.some(p => {
					if(!form[p.filed]) {
						errorTips = p.tips;
						return true;
					}
				});
				//判断两次密码
				if(form.password!=form.password2&&errorTips==""){
					errorTips="两次密码不一致！"
				}
				return errorTips;
			},
			confirm() {
				var userShareRelations = [];
				for(var i=0; i<this.divideList.length; i++){
					var id = '';
					if(this.divideList[i]['id'] != -1){
						id = this.divideList[i]['id'] + '';
					}
					var item2id = [];
					if(this.divideList[i]['item2id'] != ''){
						item2id = [this.divideList[i]['item2id']];
					}
					userShareRelations.push({
						"type": this.divideList[i]['type'],//类型：1==空调；2==公共内部;3==公共外部
						"internalDeviceNos": item2id,//用户内机，type==1时传
						"space": this.divideList[i]['area'],//面积 type!=1时传
						"shareDetailId": this.divideList[i]['itemid'],//分摊电费管理主键id
						"id": id//主键id更新时传
					});
				}

				//非空处理
				let errorTips = this.validForm(this.ownerForm)
				if(errorTips != "") {
					this.$message({
						message: errorTips,
						type: 'warning'
					});
					return
				}
				//先保存用户，再保存绑定的设备
				let cardState = this.ownerForm.cardState == '否' ? -1 : 0
				let isAutomaticBrake = this.ownerForm.isAutomaticBrake == "否" ? 0 : 1
				//let deviceNo= this.isEdit ? this.selectDeviceList.no : this.ownerForm.deviceNos[0];//this.ownerForm.deviceNos[0]
				//debugger
				if(this.isEdit && isempty(this.devNos) && isempty(this.devWaterNos) ) {
					this.$message.error('电表、水表请至少绑定一种');
					return
				}
				this.isEdit ? this.ownerForm.password = hex_md5(this.ownerForm.password) : this.ownerForm.password
				this.$api.userApi.saveOwner(this.ownerForm.id, this.ownerForm.username,
						this.ownerForm.usercode, this.ownerForm.password,
						this.ownerForm.mobile, this.nowUnit.id,
						this.ownerForm.rfid, this.ownerForm.gender,
						this.ownerForm.address, isAutomaticBrake,
						this.ownerForm.amountOfArrears, this.ownerForm.cardTypes,
						this.ownerForm.cardNumbers, this.ownerForm.balanceAlarm,
						this.ownerRoleId, cardState,
						this.ownerForm.reportDir,this.ownerForm.accountTime, userShareRelations, respon => {
							//debugger
							var that = this;
							if(!isempty(respon) && that.isEdit) {
								// if (!isempty(that.devNos)){
								// 	//debugger
								// 	that.saveAllDevice(respon.id,that.devNos)
								// }
								//
								// if (!isempty(that.devWaterNos)){
								// 	//debugger
								// 	that.saveAllDevice(respon.id,that.devWaterNos)
								// }
								var deviceNos;
								if(isempty(that.devNos)) {
									deviceNos = that.devWaterNos;
								}
								if(isempty(that.devWaterNos)) {
									deviceNos = that.devNos;
								}
								if(!isempty(that.devNos) && !isempty(that.devWaterNos)) {
									deviceNos = that.devNos+','+that.devWaterNos;
								}
								that.saveAllDevice(respon.id,deviceNos);
							}

							this.$message({
								message: '保存成功',
								type: 'success'
							});
							//this.$emit("saveSuccess")
							this.addOwnerShow = false
							this.deviceNameList = '';
							this.devNos = '';
							this.devWaterNos = '';
							ownerManagerStore.commit('getBindedDeviceNos')

						}, failure => {
							this.$message({
								type: 'error',
								message: failure
							});
						})
			},

			//保存设备
			saveAllDevice(id,devNos){

				this.$api.userApi.bindUserAndDevice('view', id, devNos, respon => {
					//刷新父组件
					this.$emit("saveSuccess")
				}, failure => {
					this.$emit("saveSuccess")
					this.$message('保存业主信息成功，绑定抄表设备失败');
					this.addOwnerShow = false
				})

			},

			setcheckedKeyNull() {
				//debugger
				//this.store.setDefaultCheckedKey(null);
				let tempList = [];
				let list = this.$refs.tree.getCheckedNodes()
				this.$emit('checkItem',tempList)
				this.$store.deviceStore.commit('setNowVirtualDeviceList', tempList)
			},

			filter(data, no) {
				var newData = data.filter(x => x.no !== no)
				newData.forEach(x => x.next && (x.next = this.filter(x.next, no)))
				return newData
			},
			defaultData(){
				//获取默认数据
				this.$api.meterReadingApi.getBaseMeterDefault(this.nowUnit.id, respon => {
					if(!isempty(respon)){
						this.ownerRoleId=respon.roleId
					}
				})
			},
			initDivideItemList(){
				this.$api.tcFentanApi.divideItemList(1, respon => {
					for(var i=0; i<respon.length; i++){
						respon[i].oneDeviceNos = JSON.parse(respon[i].oneDeviceNos);
						if(respon[i].twoDeviceNos != null){
							respon[i].twoDeviceNos = JSON.parse(respon[i].twoDeviceNos);
						}
					}
					for(var i=0; i<respon.length; i++){
						respon[i]['type'] = 1;
						this.divideItemList.push(respon[i]);

						for(var j=0; j<respon[i]['oneDeviceNos'].length; j++){
							this.divideItemACList.push({
								pid: respon[i]['id'],
								id: respon[i]['oneDeviceNos'][j],
								name: respon[i]['oneVirtualDeviceNames'][j],
							})
						}
					}
					//console.log("所有内机：" + JSON.stringify(this.divideItemACList));

					this.$api.tcFentanApi.divideItemList(2, respon => {
						for(var i=0; i<respon.length; i++){
							respon[i].oneDeviceNos = JSON.parse(respon[i].oneDeviceNos);
							if(respon[i].twoDeviceNos != null){
								respon[i].twoDeviceNos = JSON.parse(respon[i].twoDeviceNos);
							}
						}
						for(var i=0; i<respon.length; i++){
							respon[i]['type'] = 2;
							this.divideItemList.push(respon[i]);
						}
						this.$api.tcFentanApi.divideItemList(3, respon => {
							for(var i=0; i<respon.length; i++){
								respon[i].oneDeviceNos = JSON.parse(respon[i].oneDeviceNos);
								if(respon[i].twoDeviceNos != null){
									respon[i].twoDeviceNos = JSON.parse(respon[i].twoDeviceNos);
								}
							}
							for(var i=0; i<respon.length; i++){
								respon[i]['type'] = 3;
								this.divideItemList.push(respon[i]);
							}
						})
					})
				})
			},
			refreshDivideList(){
				this.divideList = [];
				this.$api.tcFentanApi.userDivideItemList(this.ownerForm.id, respon => {
					for(var i=0; i<respon.length; i++){
						var idn = respon[i]['internalDeviceNos'];
						var i2id = '';
						if(idn != undefined && idn != null && idn.length > 0){
							i2id = JSON.parse(idn)[0];
						}
						this.divideList.push({
							index: i,
							id: respon[i]['id'],
							type: respon[i]['type'] + "",
							area: respon[i]['space'],
							itemid: respon[i]['shareDetailId'],
							item2id: i2id,
						});

						console.info("refreshDivideList:"+JSON.stringify(this.divideList));


					}
				})
			},
			checkType1(item){
				return this.tempType == item['type'];
			},
			checkType2(item){
				return this.tempItem == item['pid'];
			},
		}
	}
</script>

<style>
	.addNewOwnerDialogBody {
		/*width: 100%;
		 height: 100%;*/
	}

	.addNewOwnerDialogBody .dialog-from {
		width: calc(100% - 3.3rem);
		height: 100%;
	}

	.dialog-device {
		height: 700px;
		margin-left: 40px;
	}

	.addNewOwnerDialogBody .el-dialog__body {
		display: flex;
		align-items: center;
		padding: 0;
	}
</style>